import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {FirestopTag} from '../models';

@Injectable()
export class FirestopTagService extends IoService {
  protected model = FirestopTag;
  protected listUrl = '/firestoptags/';
}
